import React from 'react';

// helpers
import {useScreenWidth} from '../../../hooks';
import {useTheme} from '@emotion/react';

// components
import CardDetailsSubscriptionMobile from './CardDetailsSubscriptionMobile';
import CardDetailsSubscriptionDesktop from './CardDetailsSubscriptionDesktop';

// types
import {
  Subscription,
  SubscriptionDetails,
} from '../../../services/ApiService/types';

export type CardDetailsSubscriptionProps =
  | {
      subscription: Subscription;
      variant: 'summary';
    }
  | {
      subscription: SubscriptionDetails;
      variant: 'detailed';
    };

const CardDetailsSubscription = (props: CardDetailsSubscriptionProps) => {
  const screenWidth = useScreenWidth();
  const theme = useTheme();

  return (
    <>
      {screenWidth < theme.screenBreakpoint.md.value ? (
        <CardDetailsSubscriptionMobile {...props} />
      ) : (
        <CardDetailsSubscriptionDesktop {...props} />
      )}
    </>
  );
};

export default CardDetailsSubscription;
